<template>
  <div class="card">
    <div class="card-body">
      <!-- Modal -->
      <div class="row">
        <div class="col-md-12">
          <div class="card-title mt-20">
            <h5 class="text-center fw-600">New Backup System</h5>
          </div>
        </div>
      </div>
      <div class="row mb-3 mt-2 mb-10">
        <div class="col-md-3">
          <div class="status-item status-item-complete">
            <i class="fa fa-check-circle status-icon status-icon-complete"></i>
            <div class="status-content">
              <div class="status-label">Functional Backups</div>
              <div class="status-count">{{ functional }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="status-item status-item-cf-red">
            <i class="fa fa-cloud status-icon status-icon-cf-red"></i>
            <div class="status-content">
              <div class="status-label">Non-Functional Backups</div>
              <div class="status-count">{{ totalOriginalRows - functional }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-2">
          <label>Select:</label>
          <select class="form-control" v-model="mainFilter">
            <option value="backup">Backup Key</option>
            <option value="lastBackup">Last Backup</option>
          </select>
        </div>
        <div v-if="mainFilter === 'backup'" class="col-md-2">
          <label>Backup:</label>
          <select class="form-control" v-model="backup">
            <option value="new">New</option>
            <option value="old">Old</option>
            <option value="both">Both</option>
            <option value="none">None</option>
          </select>
        </div>
        <div v-else-if="mainFilter === 'lastBackup'" class="col-md-2">
          <label>Last Backup:</label>
          <select class="form-control" v-model="lastBackup">
            <option value="none">None</option>
            <option value="other">Exists</option>
          </select>
        </div>
<!--        <div class="col-md-2">-->
<!--          <label>Select Plan:</label>-->
<!--          <select class="form-control" v-model="plan">-->
<!--            <option value="WPO Starter">Starter</option>-->
<!--            <option value="WPO Professional">Professional</option>-->
<!--            <option value="other">Other</option>-->
<!--          </select>-->
<!--        </div>-->
<!--        <div class="col-md-2 ">-->
<!--          <label>Select Status:</label>-->
<!--          <select class="form-control" v-model="status">-->
<!--            <option value="complete">Completed</option>-->
<!--            <option value="incomplete">Not Completed</option>-->
<!--          </select>-->
<!--        </div>-->
        <div class="col-md-2 d-flex align-items-center">
          <button data-toggle="tooltip" data-placement="top" rel="tooltip" title="This will export all backup servers based on status and plan." v-show="!exportClicked" @click="exportCSV()" type="button" :disabled="exportLoading || !(plan || status || backup)" class="btn btn-primary btn-sm mt-30">
            <div v-if="exportLoading" class="loader mini_loader"></div><span v-else class="">Generate CSV</span>
          </button>
          <vue-json-to-csv v-show="exportClicked" :json-data="csv" :labels="labels" :csv-title="getTitleForCsv()">
            <button id="export" type="button" :disabled="exportLoading" class="btn btn-primary btn-sm mr-4">
              Generate CSV
            </button>
          </vue-json-to-csv>
        </div>
        <div class="col-md-6 d-flex align-items-center justify-content-end">
          <button data-toggle="tooltip" data-placement="top" rel="tooltip" title="This will sync backup new system which includes backup agent, suspended servers, backup flag status." @click="syncData()" class="btn btn-primary btn-sm mr-10 mt-20">Sync Data</button>
          <button data-toggle="tooltip" data-placement="top" rel="tooltip" title="Refresh backup data." @click="fetchBackupSystem(1)" class="btn btn-default btn-sm mr-10 mt-20">Refresh</button>
        </div>
        <div class="col-md-2 pt-15">
          <label class="d-flex align-items-center ">
            <span>Show</span>
            <select style="width: 80px" class="custom-select custom-select-sm form-control form-control-sm datatable-dropdown ml-5 mr-5" id="grouped"  aria-describedby="grouped" required v-model="size">
              <option value="10" >10</option>
              <option value="25" >25</option>
              <option value="50" >50</option>
              <option :value="totalRows" >All</option>
            </select> <span>entries</span></label>
        </div>
        <div class="col-md-10 mt-2 d-flex justify-content-end align-items-center">
          <label for="" class="mr-10">Search: </label>
<!--          <input v-model="searchQuery" style="width: 20%" class="form-control ml-10" @keyup="onKeyUp" type="text">-->
          <div style="width: 200px" class="input-group d-flex align-items-center">
            <input @keydown.space.prevent type="text" class="form-control" placeholder="" v-model="searchQuery" aria-label="" aria-describedby="basic-addon1">
            <div class="input-group-append">
              <button class="btn btn-outline-default pt-9 pb-9 pr-15 pl-15" @click="onKeyUp" :disabled="!searchQuery" type="button"><i class="fa fa-search"></i></button>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-20">
          <!--          <table id="datatableBackup" class="table-bordered table">-->
          <!--            <thead class="thead-light">-->
          <!--            <tr>-->
          <!--              <th>IP</th>-->
          <!--              <th class="text-center">Service ID</th>-->
          <!--              <th class="text-center">Hostname</th>-->
          <!--              <th class="text-center">Domain</th>-->
          <!--              <th class="text-center">Plan</th>-->
          <!--              <th class="text-center">Backup Initialized</th>-->
          <!--              <th class="text-center">Backup Agent</th>-->
          <!--              <th class="text-center">Backup Flag</th>-->
          <!--              <th class="text-center">Is Completed</th>-->
          <!--              <th class="text-center">Created At</th>-->
          <!--              <th class="text-center">Action</th>-->
          <!--            </tr>-->

          <!--            </thead>-->
          <!--            <tbody>-->
          <!--            <tr v-for="(item, index) in allDomains" :key="item.id">-->
          <!--              <td>{{ item.ip }}</td>-->
          <!--              <td width="5%" class="text-center">{{ item.serviceId }}</td>-->
          <!--              <td class="text-center">{{ item.hostname }}</td>-->
          <!--              <td class="text-center">{{ item.domain }} <span v-if="item.hbSuspended" class="badge badge-warning ">Suspended</span></td>-->
          <!--              <td class="text-center">-->
          <!--                <span v-if="item.planName && item.planName.includes('Starter')" class="badge badge-success badge-pill">{{item.planName.replace('WPO ', '')}}</span>-->
          <!--                <span v-else-if="item.planName && item.planName.includes('Professional')" class="badge badge-info badge-pill">{{item.planName.replace('WPO ', '')}}</span>-->
          <!--              </td>-->
          <!--              <td class="text-center">-->
          <!--                <span style="display:none">{{ item.status === 'completed' ? 1 : 0 }}</span>-->
          <!--                <i v-if="item.status === 'completed'" class="fs-18 fa fa-check-circle text-success"></i>-->
          <!--                <i v-else class="fs-18 fa fa-times-circle text-danger"></i>-->
          <!--              </td>-->
          <!--              <td class="text-center">-->
          <!--                <span style="display:none">{{ item.statusApiResponse ? item.statusApiResponse.success ? 1 : 0 : -1 }}</span>-->
          <!--                <i v-if="item.statusApiResponse && item.statusApiResponse.success" class="fs-18 fa fa-check-circle text-success"></i>-->
          <!--                <i title="Backup Agent is not installed." v-else-if="item.statusApiResponse && !item.statusApiResponse.success" class=" fs-18 fa fa-times-circle text-danger"></i>-->
          <!--                <i title="Backup Agent data is not saved in database." v-else class=" fs-18 fa fa-info-circle text-warning"></i>-->
          <!--              </td>-->
          <!--              <td class="text-center">-->
          <!--                <span v-if="item.backupFlags.new_backup">-->
          <!--                  <span style="display: none">Active</span>-->
          <!--                  <i class="fa fa-check-circle text-success fs-18"></i>-->
          <!--                </span>-->
          <!--                <span v-else>-->
          <!--                  <span style="display: none">Failed</span>-->
          <!--                  <i  class="fa fa-times-circle text-danger fs-18"></i>-->
          <!--                </span>-->
          <!--              </td>-->
          <!--              <td class="text-center">-->
          <!--                <span v-if="checkCompleteStatus(item)" >-->
          <!--                  <span style="display: none">Active</span>-->
          <!--                  <i class="fa fa-check-circle text-success fs-18"></i>-->
          <!--                </span>-->
          <!--                <span v-else>-->
          <!--                  <span style="display: none">Failed</span>-->
          <!--                  <i  class="fa fa-times-circle text-danger fs-18"></i>-->
          <!--                </span>-->
          <!--              </td>-->
          <!--              <td class="text-center">-->
          <!--                {{formatDate(item.createdAt)}}-->
          <!--              </td>-->
          <!--              <td width="12%" class="text-center">-->
          <!--                <button :disabled="selectedIndex === index" @click="refreshBackupAgent(item, index)" title="Refresh Backup Agent" class="btn btn-sm btn-warning mr-2"><i :class="selectedIndex === index ? 'fa-spinner fa-spin' : 'fa-refresh'" class="fa"></i></button>-->
          <!--                <button @click="openHostbill(item)" title="View Hostbill Profile" class="btn btn-sm btn-primary"><i class="fa fa-eye"></i></button>-->
          <!--                <button title="Login as user"  class="btn btn-danger btn-sm ml-2" @click="loginAsUser(item)">-->
          <!--                  <i class="fa fa-user"></i>-->
          <!--                </button>-->
          <!--              </td>-->
          <!--            </tr>-->
          <!--            </tbody>-->
          <!--          </table>-->
          <table id="datatableBackup" class="table-bordered table">
            <thead class="thead-light">
            <tr>
              <th>IP
                <i v-if="sortKey !== 'ip' || (sortKey==='ip' && sortOrder === 'desc')" class="fa fa-sort-down" :class="(sortOrder==='desc' && sortKey === 'ip') ? 'text-default': 'text-secondary'" @click="changeSort('ip', 'asc')" />
                <i v-if="sortKey !== 'ip' || (sortKey==='ip' && sortOrder === 'asc')"  class="fa fa-sort-up " :style=" sortKey !== 'ip' ?'margin-left:-8px':'' "  :class="(sortOrder==='asc' && sortKey === 'ip') ? 'text-default': 'text-secondary'" @click="changeSort('ip', 'desc')" />
              </th>
              <th width="8%" class="text-center">Service ID
                <i v-if="sortKey !== 'serviceId' || (sortKey==='serviceId' && sortOrder === 'desc')" class="fa fa-sort-down" :class="(sortOrder==='desc' && sortKey === 'serviceId') ? 'text-default': 'text-secondary'" @click="changeSort('serviceId', 'asc')" />
                <i v-if="sortKey !== 'serviceId' || (sortKey==='serviceId' && sortOrder === 'asc')"  class="fa fa-sort-up " :style=" sortKey !== 'serviceId' ?'margin-left:-8px':'' "  :class="(sortOrder==='asc' && sortKey === 'serviceId') ? 'text-default': 'text-secondary'" @click="changeSort('serviceId', 'desc')" />
              </th>
              <th class="text-center">Hostname
                <i v-if="sortKey !== 'hostname' || (sortKey==='hostname' && sortOrder === 'desc')" class="fa fa-sort-down" :class="(sortOrder==='desc' && sortKey === 'hostname') ? 'text-default': 'text-secondary'" @click="changeSort('hostname', 'asc')" />
                <i v-if="sortKey !== 'hostname' || (sortKey==='hostname' && sortOrder === 'asc')"  class="fa fa-sort-up " :style=" sortKey !== 'hostname' ?'margin-left:-8px':'' "  :class="(sortOrder==='asc' && sortKey === 'hostname') ? 'text-default': 'text-secondary'" @click="changeSort('hostname', 'desc')" />
              </th>
<!--              <th class="text-center">Domain-->
<!--                <i v-if="sortKey !== 'domain' || (sortKey==='domain' && sortOrder === 'desc')" class="fa fa-sort-down" :class="(sortOrder==='desc' && sortKey === 'domain') ? 'text-default': 'text-secondary'" @click="changeSort('domain', 'asc')" />-->
<!--                <i v-if="sortKey !== 'domain' || (sortKey==='domain' && sortOrder === 'asc')"  class="fa fa-sort-up " :style=" sortKey !== 'domain' ?'margin-left:-8px':'' "  :class="(sortOrder==='asc' && sortKey === 'domain') ? 'text-default': 'text-secondary'" @click="changeSort('domain', 'desc')" />-->
<!--              </th>-->
              <th class="text-center">Plan
                <i v-if="sortKey !== 'planName' || (sortKey==='planName' && sortOrder === 'desc')" class="fa fa-sort-down" :class="(sortOrder==='desc' && sortKey === 'planName') ? 'text-default': 'text-secondary'" @click="changeSort('planName', 'asc')" />
                <i v-if="sortKey !== 'planName' || (sortKey==='planName' && sortOrder === 'asc')"  class="fa fa-sort-up " :style=" sortKey !== 'planName' ?'margin-left:-8px':'' "  :class="(sortOrder==='asc' && sortKey === 'planName') ? 'text-default': 'text-secondary'" @click="changeSort('planName', 'desc')" />
              </th>
<!--              <th class="text-center">Backup Initialized-->
<!--                <i v-if="sortKey !== 'status' || (sortKey==='status' && sortOrder === 'desc')" class="fa fa-sort-down" :class="(sortOrder==='desc' && sortKey === 'status') ? 'text-default': 'text-secondary'" @click="changeSort('status', 'asc')" />-->
<!--                <i v-if="sortKey !== 'status' || (sortKey==='status' && sortOrder === 'asc')"  class="fa fa-sort-up " :style=" sortKey !== 'status' ?'margin-left:-8px':'' "  :class="(sortOrder==='asc' && sortKey === 'status') ? 'text-default': 'text-secondary'" @click="changeSort('status', 'desc')" />-->
<!--              </th>-->
              <th class="text-center">Backup
                <i v-if="sortKey !== 'backup' || (sortKey==='backup' && sortOrder === 'desc')" class="fa fa-sort-down" :class="(sortOrder==='desc' && sortKey === 'backup') ? 'text-default': 'text-secondary'" @click="changeSort('backup', 'asc')" />
                <i v-if="sortKey !== 'backup' || (sortKey==='backup' && sortOrder === 'asc')"  class="fa fa-sort-up " :style=" sortKey !== 'backup' ?'margin-left:-8px':'' "  :class="(sortOrder==='asc' && sortKey === 'backup') ? 'text-default': 'text-secondary'" @click="changeSort('backup', 'desc')" />
              </th>
<!--              <th class="text-center">Backup Flag-->
<!--                <i v-if="sortKey !== 'backupFlag' || (sortKey==='backupFlag' && sortOrder === 'desc')" class="fa fa-sort-down" :class="(sortOrder==='desc' && sortKey === 'backupFlag') ? 'text-default': 'text-secondary'" @click="changeSort('backupFlag', 'asc')" />-->
<!--                <i v-if="sortKey !== 'backupFlag' || (sortKey==='backupFlag' && sortOrder === 'asc')"  class="fa fa-sort-up " :style=" sortKey !== 'backupFlag' ?'margin-left:-8px':'' "  :class="(sortOrder==='asc' && sortKey === 'backupFlag') ? 'text-default': 'text-secondary'" @click="changeSort('backupFlag', 'desc')" />-->
<!--              </th>-->
<!--              <th class="text-center">Is Completed</th>-->
              <th class="text-center">Last Backup
                <i v-if="sortKey !== 'lastBackup' || (sortKey==='lastBackup' && sortOrder === 'desc')" class="fa fa-sort-down" :class="(sortOrder==='desc' && sortKey === 'lastBackup') ? 'text-default': 'text-secondary'" @click="changeSort('lastBackup', 'asc')" />
                <i v-if="sortKey !== 'lastBackup' || (sortKey==='lastBackup' && sortOrder === 'asc')"  class="fa fa-sort-up " :style=" sortKey !== 'lastBackup' ?'margin-left:-8px':'' "  :class="(sortOrder==='asc' && sortKey === 'lastBackup') ? 'text-default': 'text-secondary'" @click="changeSort('lastBackup', 'desc')" />
              </th>
              <th class="text-center">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in allDomains" :key="item.id">
              <td>{{ item.ip }}</td>
              <td width="5%" class="text-center">{{ item.serviceId }}</td>
              <td class="text-center" :class="{'text-danger': item.statusApiResponse && !item.statusApiResponse.success && !item.backup}">{{ item.hostname }}</td>
<!--              <td class="text-center">{{ item.domain }} <span v-if="item.hbSuspended" class="badge badge-warning badge-pill">Suspended</span></td>-->
              <td class="text-center">
                <span v-if="item.planName && item.planName.includes('Starter')" class="badge badge-success badge-pill">{{item.planName.replace('WPO ', '')}}</span>
                <span v-else-if="item.planName && item.planName.includes('Professional')" class="badge badge-info badge-pill">{{item.planName.replace('WPO ', '')}}</span>
                <span v-else class="badge badge-danger badge-pill">{{item.planName ? item.planName.replace('WPO ', '') : ''}}</span>
              </td>
<!--              <td class="text-center">-->
<!--                <span style="display:none">{{ item.status === 'completed' ? 1 : 0 }}</span>-->
<!--                <i v-if="item.status === 'completed'" class="fs-18 fa fa-check-circle text-success"></i>-->
<!--                <i v-else class="fs-18 fa fa-times-circle text-danger"></i>-->
<!--              </td>-->
              <td class="text-center">
                <span data-toggle="tooltip" :title="JSON.stringify(item.statusApiResponse)" class="badge badge-pill make-cursor-pointer" :class="{'badge-success': item.backup === 'both', 'badge-info': item.backup === 'new', 'badge-danger': item.backup === 'old' || item.backup === 'none'}">{{ item.backup }}</span>
                <span v-if="!item.backup" data-placement="top"
                      data-html="true" data-toggle="tooltip" :title="JSON.stringify(item.statusApiResponse)" class="make-cursor-pointer"><i class="fa fa-info-circle text-danger"></i></span>
<!--                <i v-if="item.statusApiResponse && !item.statusApiResponse.success" class="fs-18 fa fa-check-circle text-success"></i>-->
<!--                <i title="Backup Agent is not installed." v-else-if="item.statusApiResponse && item.statusApiResponse.success" class=" fs-18 fa fa-times-circle text-danger"></i>-->
<!--                <i title="Backup Agent data is not saved in database." v-else class=" fs-18 fa fa-info-circle text-warning"></i>-->
              </td>
<!--              <td class="text-center">-->
<!--                <span v-if="item.backupFlag">-->
<!--                  <span style="display: none">Active</span>-->
<!--                  <i class="fa fa-check-circle text-success fs-18"></i>-->
<!--                </span>-->
<!--                <span v-else>-->
<!--                  <span style="display: none">Failed</span>-->
<!--                  <i  class="fa fa-times-circle text-danger fs-18"></i>-->
<!--                </span>-->
<!--              </td>-->
<!--              <td class="text-center">-->
<!--                <span v-if="checkCompleteStatus(item)" >-->
<!--                  <span style="display: none">Active</span>-->
<!--                  <i class="fa fa-check-circle text-success fs-18"></i>-->
<!--                </span>-->
<!--                <span v-else>-->
<!--                  <span style="display: none">Failed</span>-->
<!--                  <i  class="fa fa-times-circle text-danger fs-18"></i>-->
<!--                </span>-->
<!--              </td>-->
              <td class="text-center">
                {{item.lastBackup ? formatDate(item.lastBackup) : 'None'}}
              </td>
              <td width="12%" class="text-center">
                <button :disabled="selectedIndex === index" @click="refreshBackupAgent(item, index)" title="Refresh Backup Agent" class="btn btn-sm btn-warning mr-2"><i :class="selectedIndex === index ? 'fa-spinner fa-spin' : 'fa-refresh'" class="fa"></i></button>
                <button @click="openHostbill(item)" title="View Hostbill Profile" class="btn btn-sm btn-primary"><i class="fa fa-eye"></i></button>
                <button title="Go to user"  class="btn btn-danger btn-sm ml-2" @click="loginAsUser(item)">
                  <i class="fa fa-user"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <div v-if="allDomains.length > 0" class="col-md-12 d-flex justify-content-between align-items-center">
            <span class="lh-3 pull-left">
                Page {{ page}} of {{totalPages}}
            </span>
            <section class="dataTables_paginate paging_full_numbers">
              <paginate
                  v-model="page"
                  :pageCount="totalPages"
                  :clickHandler="goToPage"
                  :prevText="'Prev'"
                  :nextText="'Next'"
                  page-class="page-item"
                  prev-class="page-item"
                  prev-link-class="page-link"
                  next-class="page-item"
                  next-link-class="page-link"
                  page-link-class="page-link"
                  containerClass="pagination">
              </paginate>
            </section>
          </div>
          <div class="customer-list-info" v-if="allDomains.length === 0 && !initialLoader">
            <div class="card-text text-center text-danger mb-3 font-weight-bold">
              No Data Exists!
            </div>
          </div>
          <div v-if="initialLoader" class="loader"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import axios from "axios";
import moment from "moment";
import VueJsonToCsv from 'vue-json-to-csv'
import Paginate from 'vuejs-paginate'

export default {
  name: "newBackupSystem",
  components: {
    VueJsonToCsv, Paginate
  },
  async mounted() {
    console.log('testtt')
    this.initialLoader = true

    await this.getBackupFlags()
    await this.fetchBackupSystem(1)
  },
  data() {
    return {
      searchQuery: '',
      incomplete: 0,
      functional: 0,
      plan: '',
      status: '',
      labels: {},
      exportClicked: false,
      csvData: [],
      backup: 'both',
      lastBackup: '',
      mainFilter: 'backup',
      exportLoading: false,
      allDomains: [],
      sortKey: 'createdAt',
      sortOrder: 'desc',
      page: 1,
      size: 10,
      totalPages: 0,
      totalRows: 0,
      totalOriginalRows: 0,
      plansWithOldBackupSystemn: [],
      allBackupFlags: [],
      selectedIndex: -1,
      selectedTab: null,
      listener: null,
      initialLoader: false
    }
  },
  watch: {
    size(val){
      // this.renderDatatable()
      this.fetchBackupSystem(this.page)
    },
    searchQuery(val){
      this.searchQuery = this.searchQuery.trim()
      if(!val) {
        this.page = 1
        this.size = 10
        this.fetchBackupSystem()
      }
    }
  },
  computed: {
    functionalBackups() {
      const now = new Date();
      const arr = this.allDomains.filter(item => {
        if(item.lastBackup) {
          const date = moment(item.lastBackup); // moment auto-parses ISO format

          const fortyEightHoursAgo = moment().subtract(48, 'hours');

          return date.isAfter(fortyEightHoursAgo) && date.isBefore(moment());

        }
        return false;
      })
      console.log(arr)
      return arr.length
    },
    csv() {
      let arr = this.csvData.filter(el => !el.hbSuspended);
      // arr = arr.filter(el => this.plan === 'other' ? !el.planName || (!el.planName.includes('Starter') && !el.planName.includes('Professional')) : el.planName && el.planName.includes(this.plan))
      // if(this.status === 'completed'){
      //   arr = arr
      //       .filter(el =>
      //           el.status === 'completed' &&
      //           el.statusApiResponse && el.statusApiResponse.success &&
      //           el.backupFlag
      //       )
      //       .map(el => ({
      //         ip: el.ip,
      //         hostname: el.hostname,
      //         domain: el.domain,
      //         plan: el.planName,
      //         backupInitialized: el.status,
      //         backupAgent: el.statusApiResponse.success,
      //         backupFlag: el.backupFlag,
      //         completed: true
      //       }));
      // } else if(this.status === 'incompleted') {
      //   arr = arr
      //       .filter(el =>
      //           !(el.status === 'completed' &&
      //           el.statusApiResponse && el.statusApiResponse.success &&
      //           el.backupFlag)
      //       )
      //       .map(el => ({
      //         ip: el.ip,
      //         hostname: el.hostname,
      //         domain: el.domain,
      //         plan: el.planName,
      //         backupInitialized: el.status,
      //         backupAgent: el.statusApiResponse ? el.statusApiResponse.success : false,
      //         backupFlag: el.backupFlag,
      //         completed: false
      //       }));
      // }
      console.log('arr', arr)
      return arr.map(el => {
        return {
          ip: el.ip,
          hostname: el.hostname,
          planName: el.planName,
          backup: el.backup,
          serviceId: el.serviceId,
          lastBackup: el.lastBackup,
        }
      })
    },
    getCompleteBackupServers() {
      const allServers = this.allDomains;
      let count = 0;
      allServers.forEach((server) => {
        if(server.status === 'completed' && server.statusApiResponse && server.statusApiResponse.success && this.getBackupFlagStatus(server)) {
          count ++
        }
      })
      return count
    },
    getIncompleteBackupServers() {
      const allServers = this.allDomains;
      let count = 0;
      allServers.forEach((server) => {
        const obj = this.allBackupFlags.find(el => el.hbHostname === server.hostname)
        if(server.status !== 'completed' || !server.statusApiResponse || !server.statusApiResponse.success || !this.getBackupFlagStatus(server)) {
          count ++
        }
      })
      return count
    },
    user() {
      return this.$store.getters.user;
    },
  },
  beforeDestroy() {
    if(this.listener) {
      this.listener()
    }
  },
  methods: {
    changeSort(key, order) {
      console.log('key', key, order)
      this.sortKey = key;
      this.sortOrder = order;
      this.fetchBackupSystem()
    },
    onKeyUp() {
      if(this.searchQuery) {
        this.searchBackup()
      } else {
        this.fetchBackupSystem()
      }
    },
    goToPage(event) {
      console.log('goToPage', event)
      this.page = event;
      if(this.searchQuery) {
        this.searchBackup(event);
      } else {
        this.fetchBackupSystem(event);
      }
    },
    getTitleForCsv(){
      return `Backup_Server_${(new Date()).getTime()}`
    },
    async exportCSV(val){
      try {
        console.log('im called', val)
        this.exportLoading = true
        this.labels = {
          ip: { title: 'IP' },
          hostname: { title: 'Hostname' },
          serviceId: { title: 'Service Id' },
          planName: { title: 'Plan' },
          backup: { title: 'Backup' },
          lastBackup: { title: 'Last Backup' },
          // backupAgent: { title: 'Backup Agent' },
          // backupFlag: { title: 'Backup Flag' },
          // completed: { title: 'Is completed' },
        }
        const resp = await this.$patchStackService.post('/backup/filter', {
          grant_type: 'token',
          hash: '1a18fefe16e4ab6ae1967a2ad980f396',
          backup: this.mainFilter === 'backup' ? this.backup : null,
          lastBackup: this.mainFilter === 'lastBackup' ? this.lastBackup : null,
        });
        console.log('resp', resp.data)
        this.csvData = resp.data.rows.map(el => {
          return { ip: el.ip, hostname: el.hostname, backup: el.backup, serviceId: el.serviceId, planName: el.planName, lastBackup: el.lastBackup ? this.formatDate(el.lastBackup) : '' }
        })
        console.log('csvData', this.csvData);
        this.exportClicked = true;
        setTimeout(function() {
          const button = document.getElementById("export");
          button.click();
          this.exportClicked = false
          this.plan = ''
          this.status = ''
        }, 500);
      } catch (e) {
        this.exportLoading = false
        console.log('error 273', e.toString())
      } finally {
        this.exportLoading = false
        this.exportClicked = false
      }
    },
    async syncData() {
      const resp = await this.$patchStackService.post('/backup/sync', {
        "hash": "1a18fefe16e4ab6ae1967a2ad980f396",
        grant_type: 'token',
        hash: '1a18fefe16e4ab6ae1967a2ad980f396',
      })
      this.showToast({message: 'CRON has started for synchronizing new backup system.' , duration: 2000}, true, 'success')
    },
    checkCompleteStatus(data) {
      let flag = true;
      if(!this.getBackupFlagStatus(data)) {
        flag = false
      } if(!data.statusApiResponse || (data.statusApiResponse && !data.statusApiResponse.success)) {
        flag = false
      } if(data.status !== 'completed') {
        flag = false
      }
      return flag;
    },
    getBackupFlagStatus(data) {
      const obj = this.allBackupFlags.find(el => el.hbHostname === data.hostname);
      return obj && obj.new_backup
    },
    async getBackupFlags() {
      this.allBackupFlags = []
      const ref = await db.collection('newBackupFlags').get();
      if(ref.size) {
        ref.forEach((item) => {
          this.allBackupFlags.push({id: item.id, ...item.data()})
        })
      }
    },
    async initializeNewBackup(account, index) {
      try {
        this.selectedIndex = index;
        console.log('account', account);
        const ref = await db.collection('hostingAccounts').doc(account.uid).get();
        if(ref.exists) {
          const {accounts} = ref.data();
          const selectedAcc = accounts.find(el => el.primary.serverIP === account.ip);
          if(selectedAcc) {
            const initiateJob = await this.$http.post('/backup/new-initialize', {
              domain: selectedAcc.primary.domain,
              actionTakenBy: `${this.user.firstName} ${this.user.lastName}`,
              ip: account.ip,
              serviceId: account.hbServiceID,
              hostname: account.hbHostname,
              grant_type: 'token',
              uid: account.uid,
              email: this.user.email,
              firstName: this.user.firstName,
              lastName: this.user.lastName,
            });
            console.log('initialize backup job ', initiateJob.data)
            return this.showToast({message: 'You have successfully initialized new backup process.' , duration: 2000}, true, 'success')
          }
          return this.showToast({message: `Unable to find the required plan in database.` , duration: 2000}, true, 'danger')

        }
        return this.showToast({message: `Unable to find the account.` , duration: 2000}, true, 'danger')
      } catch (e) {
        console.log(e.toString())
        this.showToast({message: `Something went wrong while initializing new backup. ${e.toString()}` , duration: 2000}, true, 'danger')
      } finally {
        this.selectedIndex = -1;
      }

    },
    async fetchBackupSystem(pg = 1) {
      try {
        // const resp = await this.$http.post('/backup/fetch-new-backup-system', {
        //   grant_type: 'token',
        // })
        this.initialLoader = true
        this.allDomains = []
        const resp = await this.$patchStackService.post('/backup/fetch-new-backup-data', {
          grant_type: 'token',
          hash: '1a18fefe16e4ab6ae1967a2ad980f396',
          page: pg,
          size: this.size,
          sortKey: this.sortKey,
          sortOrder: this.sortOrder
        });
        console.log('resp', resp.data)
        if(resp.data.success) {
          this.allDomains = resp.data.data
          this.allDomains = this.allDomains.map(el => {
            if(el.statusApiResponse) {
              el.statusApiResponse = JSON.parse(el.statusApiResponse)
            }
            return el;
          })
          this.page = resp.data.currentPage;
          this.totalPages = resp.data.totalPages;
          this.incomplete = resp.data.incomplete;
          this.functional = resp.data.functional;
          this.totalRows = resp.data.totalItems;
          this.totalOriginalRows = resp.data.totalItems;
        }
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        this.initialLoader = false
      } catch (e) {
        console.log('error while fetching backup system', e);
      }
    },
    searchBackup: _.debounce(async function(pg = 1) {
      try {
        // const resp = await this.$http.post('/backup/fetch-new-backup-system', {
        //   grant_type: 'token',
        // })
        this.initialLoader = true
        this.allDomains = []
        const resp = await this.$patchStackService.post('/backup/search', {
          grant_type: 'token',
          hash: '1a18fefe16e4ab6ae1967a2ad980f396',
          searchQuery: this.searchQuery,
          page: pg,
          size: this.size
        });
        console.log('resp', resp.data)
        if(resp.data.success) {
          this.allDomains = resp.data.data
          this.allDomains = this.allDomains.map(el => {
            if(el.statusApiResponse) {
              el.statusApiResponse = JSON.parse(el.statusApiResponse)
            }
            return el;
          })
          this.page = resp.data.currentPage;
          this.totalPages = resp.data.totalPages;
          this.totalRows = resp.data.totalItems;
        }
        this.initialLoader = false
      } catch (e) {
        console.log('error while fetching backup system', e);
        this.initialLoader = false
      }
    }, 300),
    async fetchOldBackupPlans() {
      try {
        this.plansWithOldBackupSystemn = []
        const ref = await db.collection('newBackupFlags').where('old_backup', '==', true).where('new_backup', '==', false).get();
        if(ref.size) {
          this.plansWithOldBackupSystemn = ref.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        }
        this.$nextTick(() => {
          this.renderDatatable2();
        });
      } catch (e) {
        console.log('error while fetching backup system', e);
      }
    },
    async fetchBackups(data) {
      try {
        const {domain, serverIP, hbHostname, hbServiceID, backup} = data;

        let backups = []
        let oldBackups = []
        console.log('data', data)
        if(backup === 'new' || backup === 'both') {
          try {
            const payload = {
              action: 'list',
              id: new Date().getTime(),
              hostname: hbHostname,
              domain: domain,
              service_id: hbServiceID
            }
            console.log('payload to fetch list of backups for domian:', domain, payload)
            const response = await axios.post('https://n8n.bigscoots.dev/webhook/2bcb6dd8-bd60-44dd-a533-ccf7bfc6c8e8', {
              ...payload
            }, {
              headers: {
                Authorization: 'Bearer Oawi3r8asef#A*(Fs7e8f0ase8fa73'
              },
              timeout: 360000
            })
            const resp = response.data.data;
            console.log('data of list backup', resp);
            if (resp.Snapshots) {
              backups = resp.Snapshots.reverse()
              backups = backups.map(el => {
                return {
                  objID: el.ObjID,
                  IsOwn: el.IsOwn,
                  label: el.Time,
                  value: el.Time,
                  note: el.IsOwn ? el.Desc : 'Daily',
                  type: el.IsOwn ? 'manual' : 'back',
                  creating: false,
                  completed: true,
                  backupDate: el.Time,
                  newBackup: true
                }
              })
              console.log('final backup list', backups);
            }
          } catch (e) {
            console.log('error in list backups', e);
          }
        }
        if(backup === 'both' || backup === 'old') {
          try {
            console.log('fetching old backups')
            const response = await this.$http.post('backup', {
              ip: serverIP,
              domain: domain,
              grant_type: 'token',
              type: 'daily'
            });
            const data = response.data.data;
            oldBackups = data.reverse();
            oldBackups = oldBackups.map((item) => {
              let backupDate = null;
              let completed = true;
              const parsedArray = item.split('_');
              if (parsedArray.length > 1) {
                backupDate = parsedArray[1];
                completed = false;
              } else {
                backupDate = item;
              }
              let newDate = backupDate;

              if (!isNaN(new Date(newDate))) {
                return {
                  label: moment(backupDate).format('MMMM Do, YYYY, h:mm:ss A'),
                  value: item,
                  note: 'Daily Backup',
                  type: 'back',
                  completed,
                  backupDate,
                  creating: false,
                  newBackup: false
                };
              }
            });
          } catch (e) {
            console.log('error in list backups old', e);
          }
        }

        const finalBackups = [...backups, ...oldBackups,]
        return finalBackups.sort((a, b) => moment(b.backupDate) - moment(a.backupDate))
      } catch (e) {
        console.log('error in getBackups', e);
        return []
      }
    },
    async refreshBackupAgent(data, index) {
      try {
        console.log('data', data)
        this.selectedIndex = index;
        let serviceId = ''
        let ip = ''
        let planName = '';
        let hostname = ''
        let domain = ''
        let statusApiResponse = {}
        let backup = ''
        let lastBackup = ''
        if(data.uid) {
          const ref = await db.collection('hostingAccounts').doc(data.uid).get();
          if(ref.exists) {
            const {accounts} = ref.data();
            const selectedAccount = accounts.find(el => el.primary.hbHostname === data.hostname)
            console.log(selectedAccount)
            if(selectedAccount) {
              serviceId = selectedAccount.primary.hbServiceID
              domain = selectedAccount.primary.domain
              ip = selectedAccount.primary.serverIP
              hostname = selectedAccount.primary.hbHostname
              planName = selectedAccount.planName
            } else {
              this.showToast({message: `Sorry! We couldn’t find the selected hostname in WPO to sync the data.` , duration: 2000}, true, 'danger')

              return true
            }
          }
        }
        try {
          const { data: responseData } = await axios.post('https://n8n.bigscoots.dev/webhook/0d771283-7e97-44c8-92e0-0266757a1e25', {
            "destination_ip": ip,
            "hostname": hostname,
            "service_id": serviceId
          }, {
            headers: {
              'Authorization':'Bearer PASDOFIK#fALWF()28a)@8a',
              'Content-Type': 'application/json'
            }
          })
          statusApiResponse = JSON.stringify(responseData)
          backup = responseData.backup;
        } catch (e) {
          console.log('error at checking backup status', e)
          if(e.response && e.response.data) {
            statusApiResponse = JSON.stringify(e.response.data)
          }
        }
        console.log('domain', domain)
        if(backup) {
          console.log('backup', backup)
          const backups = await this.fetchBackups({backup, domain, hbHostname: hostname, hbServiceID: serviceId, serverIP: ip});
          console.log('backups', backups);
          lastBackup = backups && backups.length ? backups[0].backupDate : ''
        }
        // await db.collection('newBackupSystem').doc(data.id).update({statusApiResponse: {success}, serviceId, hostname, domain}, )
        const resp = await this.$patchStackService.post('/backup/create', {
          id: data.id,
          payload: {
            ip,
            planName,
            statusApiResponse,
            serviceId,
            hostname,
            backup,
            lastBackup
          },
          hash: '1a18fefe16e4ab6ae1967a2ad980f396'
        })
        console.log('resp', resp.data)
        const obj = this.allDomains.find(row => row.id === resp.data.data.id);
        console.log('indexs', obj)
        if (!!obj) {
          const allKeys = Object.keys(resp.data.data);
          for (const key of allKeys){
            if(key === 'statusApiResponse') {
              obj[key] = JSON.parse(resp.data.data[key]);
            } else {
              obj[key] = resp.data.data[key];
            }
          }
        }
        this.showToast({duration: 8000,message: `You have successfully refreshed the row.`}, true, 'success')
      }
      catch (e) {
        console.log('error', e, (typeof(e)))
        // await db.collection('newBackupSystem').doc(data.id).update({statusApiResponse: {success: false}})
        this.showToast({message: `Something went wrong while checking status for backup agent,` , duration: 2000}, true, 'danger')
      } finally {
        this.selectedIndex = -1
      }
    },
    formatDate(date) {
      return moment.tz(date, 'America/Chicago').local().format('MMMM Do, YYYY, h:mm:ss A')
    },
    async openHostbill(row){
      const {uid} = row;
      const ref = await db.collection('users').doc(uid).get();
      if(ref.exists) {
        const {customerID} = ref.data()
        window.open(`https://portal.bigscoots.com/admin/?cmd=clients&action=show&id=${customerID}`, '_blank')
      }
    },
    loginAsUser(data){
      this.$router.push(`/admin/edit-user/${data.uid}`)
      // window.open(`https://wpo.bigscoots.com/user/dashboard?id=${data.uid}`,'WPO-Bigscoots');
    },
    renderDatatable() {
      console.log('rendering', $.fn.DataTable.isDataTable('#datatableBackup'))
      if($.fn.DataTable.isDataTable('#datatableBackup')) {
        $(`#datatableBackup`).DataTable().destroy();
      }
      setTimeout(function () {
        $(`#datatableBackup`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo" : false,
          "ordering": true,
          order: [[8, 'desc']],
          "columnDefs": [
            { "orderable": false, "targets": [10] } // Disable sorting on the first and third columns
          ],
          initComplete: function () {
            let api = this.api();
            $('.dataTables_filter input').on('input', function () {
              let newValue = $(this).val().replace(/\s/g, ''); // Remove spaces
              $(this).val(newValue);
              api.search(newValue).draw();
            });
          }
        });
      }, 0)
      // $(`#datatableBackup`).dataTable({
      //   pagingType: "full_numbers",
      //   paging: true,
      //   destroy: true,
      //   retrieve: true,
      //   deferRender: true,
      //   stateSave: false,
      //   "bInfo" : false,
      //   "ordering": true,
      //   'columnDefs': [ {
      //     'targets': [8], // column index (start from 0)
      //     'orderable': false, // set orderable false for selected columns
      //   },
      //   ],
      //   order: [[7, 'desc']]
      // });
    },
    renderDatatable2() {
      console.log('rendering', $.fn.DataTable.isDataTable('#datatableOldBackup'))
      if($.fn.DataTable.isDataTable('#datatableOldBackup')) {
        $(`#datatableOldBackup`).DataTable().destroy();
      }
      $(`#datatableOldBackup`).dataTable({
        pagingType: "full_numbers",
        paging: true,
        destroy: true,
        retrieve: true,
        deferRender: true,
        stateSave: false,
        "bInfo" : false,
        "ordering": true,
        'columnDefs': [ {
          'orderable': false, // set orderable false for selected columns
        }],
      });
    },

  },
}
</script>


<style scoped lang="scss">

.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}

.status-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  cursor: pointer;
  border: 1.5px solid #e9ecef;
  border-left: 4px solid #e9ecef;
  border-radius: 8px;
  margin-right: 10px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.status-item-pending {
  border-color: #fbc658;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(251, 198, 88, 0.05), #ffffff);
}

.status-item-pending .status-label {
  color: #fbc658;
}

.status-item-inprogress {
  border-color: #51cbce;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(81, 203, 206, 0.05), #ffffff);
}

.status-item-inprogress .status-label {
  color: #51cbce;
}

.status-item-complete {
  border-color: #6bd098;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(107, 208, 152, 0.05), #ffffff);
}

.status-item-complete .status-label {
  color: #6bd098;
}

.status-item-cf-green {
  border-color: #6bd098;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(107, 208, 152, 0.05), #ffffff);
}

.status-item-cf-green .status-label {
  color: #6bd098;
}

.status-item-cf-red {
  border-color: #9e9e9e;
  border-left-width: 4px;
  background: linear-gradient(to right, rgba(158, 158, 158, 0.05), #ffffff);
}

.status-item-cf-red .status-label {
  color: #9e9e9e;
}

.status-icon {
  font-size: 22px;
  margin-right: 14px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  flex-shrink: 0;
}

.status-icon-pending {
  color: #fbc658;
  background: rgba(251, 198, 88, 0.1);
}

.status-icon-inprogress {
  color: #51cbce;
  background: rgba(81, 203, 206, 0.1);
}

.status-icon-complete {
  color: #6bd098;
  background: rgba(107, 208, 152, 0.1);
}

.status-icon-cf-green {
  color: #6bd098;
  background: rgba(107, 208, 152, 0.1);
}

.status-icon-cf-red {
  color: #9e9e9e;
  background: rgba(158, 158, 158, 0.1);
}

.status-content {
  flex: 1;
  min-width: 0;
}

.status-label {
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 4px;
}

.status-count {
  font-size: 24px;
  font-weight: 700;
  color: #6c757d;
  line-height: 1.2;
  letter-spacing: -0.5px;
}
</style>
